import {button,escapeHtml} from '../ui/components.js';
import {
  editProductPreferenceState,
  editSmokingGoalState,
  experienceOptions,
  productPreferenceOptions,
  smokingGoalOptions
} from './onboarding-fields.js';

function checked(value,selected){
  return selected.includes(value)?' checked':'';
}

function radioCards(name,options,selected){
  return '<div class="choice-grid">'+options.map(option=>
    '<label class="choice-card"><input type="radio" name="'+escapeHtml(name)+'" value="'+escapeHtml(option.key)+'"'+(selected===option.key?' checked':'')+'><span class="choice-card-copy"><strong>'+escapeHtml(option.label)+'</strong>'+(option.description?'<small>'+escapeHtml(option.description)+'</small>':'')+'</span></label>'
  ).join('')+'</div>';
}

function checkboxCards(name,options,selected){
  return '<div class="choice-grid">'+options.map(option=>
    '<label class="choice-card"><input type="checkbox" name="'+escapeHtml(name)+'" value="'+escapeHtml(option.key)+'"'+checked(option.key,selected)+'><span class="choice-card-copy"><strong>'+escapeHtml(option.label)+'</strong></span></label>'
  ).join('')+'</div>';
}

function otherField({id,label,value}){
  return '<label class="field onboarding-other" for="'+escapeHtml(id)+'"><span class="field-label">'+escapeHtml(label)+'</span><input id="'+escapeHtml(id)+'" name="'+escapeHtml(id)+'" type="text" maxlength="160" value="'+escapeHtml(value||'')+'"></label>';
}

function actions({primary='Dalej',allowSkip=true}={}){
  return '<div class="actions">'+button({id:'onboarding-next',label:primary})+(allowSkip?button({id:'onboarding-skip',label:'Dokończę później',variant:'ghost'}):'')+'</div>';
}

export function experienceOnboardingMarkup(profile={}, {locale='pl'}={}){
  const selected=profile.experienceLevel||null;
  return '<form id="smokehouse-onboarding-form" class="onboarding-form" data-step="experience"><div class="onboarding-copy"><span class="eyebrow">Krok 1</span><h2>Jak oceniasz swoje doświadczenie?</h2><p>To ustawienie wpływa na poziom szczegółowości przyszłych podpowiedzi, ale nie ogranicza żadnej funkcji.</p></div>'+radioCards('experience_level',experienceOptions({locale}),selected)+actions()+'</form>';
}

export function goalsOnboardingMarkup(profile={}, {locale='pl'}={}){
  const state=editSmokingGoalState(profile);
  const unknownNotice=state.unknown.length?'<p class="auth-note">Zachowaliśmy '+escapeHtml(state.unknown.length)+' starsze ustawienie, którego nie ma w aktualnym katalogu.</p>':'';
  return '<form id="smokehouse-onboarding-form" class="onboarding-form" data-step="goals"><div class="onboarding-copy"><span class="eyebrow">Krok 2</span><h2>Co chcesz osiągnąć?</h2><p>Możesz wybrać kilka celów. Ten krok jest opcjonalny i możesz go później edytować.</p></div>'+checkboxCards('smoking_goals',smokingGoalOptions({locale}),state.selected)+otherField({id:'smoking-goal-other',label:'Inny cel',value:state.otherText})+unknownNotice+actions()+'</form>';
}

export function productsOnboardingMarkup(profile={}, {locale='pl'}={}){
  const state=editProductPreferenceState(profile);
  const unknownNotice=state.unknown.length?'<p class="auth-note">Zachowaliśmy '+escapeHtml(state.unknown.length)+' niestandardową kategorię z poprzedniej wersji.</p>':'';
  return '<form id="smokehouse-onboarding-form" class="onboarding-form" data-step="products"><div class="onboarding-copy"><span class="eyebrow">Krok 3</span><h2>Co najczęściej wędzisz?</h2><p>Wybór jest opcjonalny. Posłuży później do porządkowania receptur i planera.</p></div>'+checkboxCards('product_preferences',productPreferenceOptions({locale}),state.selected)+otherField({id:'product-preference-other',label:'Inna kategoria',value:state.otherText})+unknownNotice+actions()+'</form>';
}

export function smokehouseOnboardingStepMarkup({step,profile={},locale='pl'}={}){
  switch(step){
    case 'experience':return experienceOnboardingMarkup(profile,{locale});
    case 'goals':return goalsOnboardingMarkup(profile,{locale});
    case 'products':return productsOnboardingMarkup(profile,{locale});
    case 'smoker':return '<section class="onboarding-form" data-step="smoker"><div class="onboarding-copy"><span class="eyebrow">Krok 4</span><h2>Dodaj pierwszą wędzarnię</h2><p>Sprzęt możesz opisać teraz albo wrócić do tego później.</p></div><div class="actions">'+button({id:'onboarding-add-smoker',label:'Dodaj wędzarnię'})+button({id:'onboarding-skip',label:'Dokończę później',variant:'ghost'})+'</div></section>';
    default:throw new TypeError('Unsupported onboarding step');
  }
}
